import {z} from 'zod';

export const dlqMessagesResponseSchema = z.object({
  status: z.string(),
  data: z.array(
    z.object({
      id: z.string(),
      body: z.union([z.string(), z.record(z.unknown())]),
      receiptHandle: z.string().optional(),
      attributes: z.record(z.any()).optional(),
      groupId: z.string().optional(),
      deduplicationId: z.string().optional(),
      md5OfBody: z.string().optional(),
    })
  ),
  timestamp: z.string(),
});
